import { ProjectSearchCard } from '@platform/client/schemas';
import { CountryIcon, Icon, ISO3166Alpha2Code, PillBadge } from '@platform/components';

type ProjectCardProps = {
  project: ProjectSearchCard;
};

export const ProjectCard = (props: ProjectCardProps) => {
  const { location, name, roleType, image, id, organizationName, expertises, countryCode } =
    props.project;

  return (
    <div className='min-w-[300px] h-full flex flex-col bg-white shadow-md rounded-xl'>
      <div className='w-full h-[110px] flex items-center justify-center border-b border-gray-100 p-5'>
        {image ?
          <img src={image} className='h-[72px] w-full object-contain' />
        : <Icon type='building-04' size='72' additionalClassNames='text-gray-700' />}
      </div>
      <div className='flex flex-col gap-3 p-4 flex-1'>
        <div>
          <div className='text-xs font-medium tracking-wide text-gray-500 uppercase'>
            {roleType}
          </div>
          <div className='font-semibold text-base text-gray-700 line-clamp-3 mt-1'>{name}</div>
          <div className='text-sm text-gray-500 mt-1 line-clamp-2'>{organizationName}</div>
          {location && (
            <div className='text-sm text-gray-500 flex flex-row items-center gap-1 mt-1'>
              {countryCode && (
                <CountryIcon alpha2={countryCode as ISO3166Alpha2Code} height={16} />
              )}
              {location}
            </div>
          )}
        </div>
        {expertises.length > 0 && (
          <div className='flex flex-row gap-2 flex-wrap'>
            {expertises.map((expertise) => (
              <PillBadge key={expertise} size='md' variant='plain' color='gray'>
                {expertise}
              </PillBadge>
            ))}
          </div>
        )}
        <a
          className='w-full flex items-center justify-center gap-x-1 mt-auto h-10 px-3.5 py-2.5 border border-gray-200 rounded-lg shadow-xs text-sm font-semibold text-gray-500 bg-white cursor-pointer'
          href={`/platform/directory/projects/${id}`}
        >
          See project
          <Icon type='chevron-right' size='20' />
        </a>
      </div>
    </div>
  );
};
